import script from "./Icon-button.vue?vue&type=script&setup=true&lang=js"
export * from "./Icon-button.vue?vue&type=script&setup=true&lang=js"

import "./Icon-button.vue?vue&type=style&index=0&id=3f0bd643&lang=scss&scoped=true"

import exportComponent from "/home/herman/Документи/Work/uhmi-web-maps/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3f0bd643"]])

export default __exports__